const NAMESPACE = 'rs-home';

const PermanentStorage = Object.freeze({
  /**
   * Searches for previously set values and returns them
   * @arg {string} key A dot-delimited itentifier for the value
   * @return {} The previously stored value, in its original type, or null if not found
   */
  get: (key) => JSON.parse(localStorage.getItem(`${NAMESPACE}.${key}`)),
  /**
   * Stores a value that persists across sessions
   * @arg {string} key A dot-delimited itentifier for the value
   * @arg {} value The content to be stored
   * @return {undefined}
   */
  set: (key, value) =>
    localStorage.setItem(`${NAMESPACE}.${key}`, JSON.stringify(value)),

  remove: (key) => localStorage.removeItem(`${NAMESPACE}.${key}`),
});

export const DATA = Object.freeze({
  USER_PREFERENCES: 'user-pref',
});

export default PermanentStorage;
